import { render, staticRenderFns } from "./LicenseDeliveriesTab.vue?vue&type=template&id=9507b212&lang=pug"
import script from "./LicenseDeliveriesTab.vue?vue&type=script&lang=js"
export * from "./LicenseDeliveriesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports